import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";
import { TextFieldInput } from "../../../../Forms/TextFieldInput";
import { BidPack } from "../../BidPack";
import { BidPackTransportTypeSelect } from "../BidPackTransportTypeSelect";
import { isElementInArray } from "../../../../Utils/arrays";
import { nameOf } from "../../../../Utils/nameOf";

export const BidPackBase = ({ disabledFields }: MdmFormProps) => {
  const {
    control,
    formState: { disabled: isFormDisabled },
  } = useFormContext<BidPack>();

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <TextFieldInput control={control} name="Name" required disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={3}>
        <BidPackTransportTypeSelect
          control={control}
          name="TransportType"
          disabled={
            isElementInArray(disabledFields, nameOf<BidPack>("TransportType")) || isFormDisabled
          }
        />
      </Grid>
    </BorderedFormGrid>
  );
};
